import httpClient from "Api/httpClient";

const END_POINT = "/fe_part_categories";

const getFePartCategories = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getFePartCategory = (category_id) => {
    if (!category_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + category_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printFePartCategory = (category_id) => {
    if (!category_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?category_id=" + category_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createFePartCategories = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateFePartCategories = (payload, category_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + category_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteFePartCategories = (category_id) => {
    const DELETE_END_POINT = END_POINT + "/" + category_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getFePartCategories, getFePartCategory, printFePartCategory, createFePartCategories, updateFePartCategories, deleteFePartCategories };
